import React from 'react';
import classNames from 'classnames';
import { MessageBox } from 'Views/Components/_HumanWritten/MessageBox/MessageBox';

export interface RestrictedModeBannerProps {
	pageWithSidebar: boolean;
}

/**
 * Shown in the booking wizard when a discounted booking limits what staff can change.
 *
 * Rendered as the first child of `.booking-wizard-step-content-background`, which is where its width
 * and gutters come from — see `.restricted-mode__banner` in booking-wizard.scss. It used to sit inside
 * the fixed progress bar, where it ran under the sidebar and inherited that bar's box-shadow, and it
 * used to reference `.restricted-mode__banner` as its only class, which had no definition at all.
 */
export function RestrictedModeBanner({ pageWithSidebar }: RestrictedModeBannerProps) {
	return (
		<MessageBox
			status="warning"
			slim
			// `mt-3` because the content area's top padding is clearance for the fixed progress bar,
			// not spacing — without it the banner sits hard against the bar's bottom edge.
			//
			// `noBottomMargin` because the step content below already opens with its own `$space-sm`
			// of top padding; the box's default margin stacked on top of that as a ~36px gap.
			noBottomMargin
			className={classNames('restricted-mode__banner mt-3', {
				'restricted-mode__banner--sidebar': pageWithSidebar,
			})}
			testId="restricted-mode-banner"
		>
			As this booking has been discounted, you are restricted to what you can alter.
		</MessageBox>
	);
}
